import { createContext, useContext, useEffect, useState } from "react";
import useGet from "../global/hooks/useGet";
import { openErrorNotification } from "../global/utils/toast";

export const OptionsContext = createContext([]);

export const OptionsProvider = ({ children }) => {
  const [configOptions, setConfigOptions] = useState(null);
  const [userData, setUserData] = useState(
    JSON.parse(sessionStorage.getItem("userData"))
  );
  const token = userData ? userData?.access_token : null;
  const optionUrl = token
    ? `${process.env.REACT_APP_API_URL}/api/common/options/`
    : null;
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionRefetch,
  } = useGet(optionUrl);
  useEffect(() => {
    if (optionsData) {
      setConfigOptions(optionsData);
    }
  }, [optionsData]);

  useEffect(() => {
    if (optionDataError) {
      openErrorNotification(
        optionDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [optionsData, optionDataError]);

  return (
    <OptionsContext.Provider
      value={{
        configOptions,
        setConfigOptions,
        setUserData,
        optionRefetch,
        optionDataLoading,
      }}
    >
      {children}
    </OptionsContext.Provider>
  );
};

// Custom hook for easy access to the context
export const useOptions = () => {
  const context = useContext(OptionsContext);

  if (context === undefined) {
    throw new Error("useOptions must be used within an OptionsProvider");
  }

  return context;
};
